import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    {
      path: '/:screenId',
      name: 'home',
      component: Home
    },

    {
      path: '/:screenId/:urlSegment',
      name: 'category',
      component: () => import('./views/Category.vue'),
    },

    {
      path: '/:screenId/:urlSegment/:subUrlSegment',
      name: 'subCategory',
      component: () => import('./views/SubCategory.vue'),
    },

    {
      path: '/:screenId/:urlSegment/:subUrlSegment/:actUrlSegment',
      name: 'activity',
      component: () => import('./views/Activity.vue'),
    },
  ]
})